import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polygon,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(
        Polygon,
        {
          points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3",
          stroke: `${color}`
        }
      )
    }
  );
};
Icon.displayName = "Filter";
const Filter = memo(themed(Icon));
export {
  Filter
};
//# sourceMappingURL=filter.js.map
